const messages = {
  es: {
    translations: {
      titles: {
        home: 'Home',
        contents: 'Contenido',
        integration: 'Integración',
        contact: 'Contacto',
        compliance: 'Compliance',
        signup: 'Registrarse',
        signupSuccess: 'Inscripción Realizada',
        signin: 'Iniciar sesión',
        login: 'Inicio de sesión',
        finalizeAccount: 'Complete su registro',
        guardianData: 'Datos del Tutor Legal',
        forgotPassword: 'Olvide mi contraseña',
        searchResults: 'Resultados de la búsqueda',
        pageNotFound: 'Página no encontrada',
        adjustImage: 'Ajusta tu foto',
        account: 'Perfil',
        admin: 'Admin',
        help: 'Ayuda',
        rate: 'Evaluar',
        rated: 'Evaluado',
        rateQuestion: '¿Qué te pareció este contenido?',
        profileData: 'Datos personales',
        permissions: 'Notificaciones y permisos',
        plan: 'Plan',
        config: 'Configuración',
        mouse: 'Ratón',
        keyboard: 'Teclado',
        trackpad: 'Panel Táctil',
        organs: 'Cuerpos y Sistemas',
        completeAnatomy: 'Anatomía Completa',
        topographicAnatomy: 'Anatomía Topográfica',
        systemicAnatomy: 'Anatomía Sistémica',
        cellStructure: 'Células y tejidos',
        cytology: 'Citología',
        histology: 'Histología',
        development: 'Funciones corporales y desarrollo',
        embryology: 'Embriología',
        physiology: 'Fisiología',
        specialties: 'Clínica integrada',
        radiology: 'Radiología',
        pathology: 'Patología',
        simulator: 'Simulador',
        api: 'API BioAtlas',
        institutions: 'Instituciones',
        whiteLabel: 'White Label',
        VR: 'Realidad Virtual 3D',
        multiplatform: 'Multiplataforma',
        animations: 'Animaciones interactivas en 3D',
        accessControl: 'Control de acceso',
        languages: 'Disponible en 3 idiomas',
        platform:
          'Transforma la manera en que tu institución enseña ciencias de la salud.',
        modules:
          'Varios módulos de Enseñanza para la Salud en una sola plataforma',
        cadaver: 'Cadáver Virtual',
        cadaver3D: 'Cádaver Virtual 3D',
        atlas3D: 'Atlas Anatómico 3D',
        blades: 'Láminas Histológicas y Histopatológicas',
        simulations: 'Simulación médica',
        cardiacCycle: 'Ciclo cardíaco del corazón',
        fiberContraction: 'Contracción de la fibra muscular',
        potentialGeneration: 'Generación y conducción del potencial de acción',
        hematosis: 'Hematosis',
        synapticTransmission: 'Transmisión sináptica',
        lungVentilation: 'Ventilación pulmonar',
        pathophysiology: 'Fisiopatologia',
        'pathologicalConditions.1': 'Acné',
        'pathologicalConditions.2': 'Afecciones pleurales',
        'pathologicalConditions.3': 'Anemia falciforme',
        'pathologicalConditions.4': 'Asma',
        'pathologicalConditions.5': 'Cardiopatía isquémica',
        'pathologicalConditions.6': 'Desviaciones de la columna vertebral',
        'pathologicalConditions.7': 'Diabetes mellitus tipo 1',
        'pathologicalConditions.8': 'Diabetes mellitus tipo 2',
        'pathologicalConditions.9': 'Distensión muscular',
        'pathologicalConditions.10': 'Enfermedad de Graves',
        'pathologicalConditions.11': 'Enfermedad ulcerosa péptica',
        'pathologicalConditions.12': 'Gastritis',
        'pathologicalConditions.13': 'Fracturas óseas',
        'pathologicalConditions.14': 'Neumonía',
        'pathologicalConditions.15': 'Síndrome de ovario poliquístico',
        'pathologicalConditions.16': 'Sinusitis',
        'pathologicalConditions.17': 'Tiroiditis de Hashimoto',
        'pathologicalConditions.18': 'Trombosis',
        'pathologicalConditions.19': 'Tromboembolismo pulmonar',
        'pathologicalConditions.20': 'Tuberculosis',
        'pathologicalConditions.21': 'Urticaria',
        histopathology: 'Histopatologia',
        'histopathology.1': 'Enfermedades del sistema respiratorio',
        'histopathology.2': 'Enfermedades del sistema cardiovascular',
        'histopathology.3': 'Enfermedades del sistema digestivo',
        'histopathology.4': 'Trastornos de la circulación sanguínea',
        'histopathology.5': 'Tumor',
        'histopathology.6': 'Enfermedades del sistema nervioso',
        'histopathology.7': 'Enfermedades del sistema genital',
        'histopathology.8': 'Enfermedades del sistema urogenital',
        'histopathology.9': 'Inflamación',
        'histopathology.10': 'Lesión y reparación de células y tejidos',
        'histopathology.11': 'Enfermedades del sistema endocrino',
        'histopathology.12': 'Enfermedades inmunológicas',
        'histopathology.13':
          'Enfermedades de los sistemas muscular y esquelético',
        'histopathology.14': 'Enfermedades del sistema hematopoyético',
        cardiology: 'Cardiologia / Urgencias cardíacas',
        firstAid: 'Primeros auxilios',
        pulmonology: 'Neumología',
        infectology: 'Infectología',
        neurology: 'Neurología',
        vascular: 'Vasculares',
        autoImmune: 'Reumatismo / Autoinmune',
        survey: 'Hola, ¿nos ayudan a mejorar BioAtlas?',
        collections: 'Colecciones',
        learningPaths: 'Trilhas',
        deleteCollections: 'Desea eliminar ',
        shareCollection: 'Compartir contenido para ',
        addToMyCollection: 'Añadir a mi colección',
        explore: 'Explorar',
        'features.collections': 'Compartición de Colecciones',
        'features.multiplatform': 'Multiplataforma',
        'features.laboratory': 'Reducción de Costos de Laboratorio',
        'features.support': 'Apoyo en Investigación y Estudios de Caso',
        'features.integration': 'Integración',
        'features.languages': 'Disponible en 3 Idiomas',
        pathologicalConditions: 'Pathological conditions',
        'radiology.1': 'Tomografías computarizadas',
        'radiology.2': 'Resonancias magnéticas',
        'radiology.3': 'Radiografías computarizadas',
        'radiology.4': 'Rayos X',
        'radiology.5': 'Ultrasonido',
        'cytology1.1': 'Virus',
        'cytology1.2': 'Célula Bacteriana',
        'cytology1.3': 'Célula Eucariota de Origen Animal',
        'cytology1.4': 'Célula del Sistema Inmunológico',
        'cytology1.5': 'Neurona',
        'cytology1.6': 'Célula Adiposa',
        'cytology1.7': 'Sistema ABO',
        'cytology1.8': 'Célula Sanguínea',
        'cytology1.9': 'Fibra Muscular',
        'cytology1.10': 'Islotes de Langerhans',
        'cytology1.11': 'Folículo Tiroideo',
        'cytology2.1': 'Difusión Simple',
        'cytology2.2': 'Difusión Facilitada',
        'cytology2.3': 'Bomba de Sodio y Potasio',
        'cytology2.4': 'Cotransporte',
        'cytology2.5': 'Contratransporte'
      },
      subtitles: {
        signup: 'Rellene la información para registrarse',
        validationSent: 'Información enviada por correo electrónico',
        signin: 'Inicie la sesión para acceder a su cuenta',
        finalizeAccount: 'Rellene el resto de la información',
        fillInfo: 'Complete la información a continuación:',
        resetPassword: 'Necesitas cambiar tu contraseña:',
        resetToken: 'Recibirás un token para cambiar tu contraseña',
        pageNotFound: 'Lo sentimos, hubo un error en nuestra página.',
        rightsReserved: 'Todos los derechos reservados.',
        tabText: 'Contenido Digital Interactivo para la Salud',
        group: 'Somos una empresa del Grupo Afya',
        sales: 'Póngase en contacto con nuestro equipo de ventas',
        detail: 'Informaciones',
        rotate: 'Girar',
        moreTools: 'Más herramientas',
        pin: 'Pin',
        ruler: 'Escala',
        arrow: 'Flecha',
        savePin: 'Guardar Pin',
        saveArrow: 'Guardar Flecha',
        saveRectangle: 'Guardar Rectángulo',
        fullscreen: 'Pantalla completa',
        info: 'Informaciones',
        move: 'Mover',
        select: 'Seleccionar',
        camera: 'Mover cámara',
        zoom: 'Zoom',
        resetZoom: 'Restablecer zoom',
        deselect: 'Eliminar selección',
        focus: 'Centrarse',
        selectMultiple: 'Seleccione varios',
        hide: 'Esconder',
        help: 'Ayuda',
        nextChapter: 'Próximo capítulo',
        previousChapter: 'Capítulo anterior',
        save: 'Guardar',
        saveNew: 'Guardar nuevo',
        animationPanel: 'Panel de animación',
        recentralize: 'Recentrar',
        undoAction: 'Deshacer acción',
        advanceAction: 'Rehacer acción',
        reset: 'Restablecer',
        playPause: 'Play/Pausa',
        restartAnimation: 'Reiniciar animación',
        speed: 'Velocidad',
        ClosePanelMinimize: 'Cerrar panel / Minimizar',
        basicTools: 'Herramientas básicas',
        animationControl: 'Control de animación',
        isolate: 'Isolar',
        tree: 'Árbol de anatomía',
        textbox: 'Cuadro de texto',
        tag: 'Etiqueta',
        cutTool: 'Herramienta de recorte',
        turn: 'Voltear',
        menu: 'Menu',
        increaseZoom: 'Aumentar zoom',
        decreaseZoom: 'Disminuir zoom',
        originalZoom: 'Reposicionar',
        bladeMessage:
          'Para que funcionen los atajos de teclado, primero haga clic en la imagen y luego presione la tecla',
        organ: 'Organo',
        tissue: 'Tejido',
        color: 'Colorante',
        section: 'Sección',
        partners1: 'Únete a más de',
        partners2: 'instituciones educativas en',
        partners3: 'países de todo el mundo',
        completeAnatomy:
          'Ofrezca la base curricular definitiva en Anatomía Humana.',
        completeAnatomy2: `Acceda al <b>Cadáver Virtual</b> y al <b>Atlas 3D</b> para una navegación detallada. Este módulo integral cuenta con <b>más de 2.500 estructuras clasificadas</b>, organizadas en 12 sistemas y 9 regiones, disponibles en los modelos <b>Masculino y Femenino</b>. Garantice la <b>calidad y estandarización</b> de la enseñanza en todas las disciplinas de Ciencias de la Salud.`,
        completeAnatomy3:
          'La Anatomía Humana es la ciencia que estudia la morfología y la organización del cuerpo humano mediante la observación y el análisis de sus estructuras macroscópicas constitutivas. Este análisis está correlacionado con el funcionamiento de las distintas partes y los mecanismos de formación y respuesta a factores ambientales, genéticos y temporales. Puede clasificarse, a partir de la separación de las piezas, en Sistemas Orgánicos y Regiones Anatómicas. En este módulo se incluyeron modelos anatómicos representativos del cuerpo masculino y femenino, además del cadáver virtual masculino.',
        completeAnatomy4:
          'Cuenta con más de 2.500 estructuras etiquetadas de todos los sistemas anatómicos del cuerpo humano. Este módulo está dividido en modelos Masculino y Femenino y organizado según 12 sistemas anatómicos y 9 regiones.',
        completeAnatomy5:
          'Un cuerpo humano* real dividido en 1.878 cortes y fotografiado con equipo de altísima resolución, reconstruido digitalmente en 3D. El Cadáver Virtual conserva los colores, está segmentado y mapeado para una visualización completa.',
        topographicAnatomy: 'El Laboratorio de Anatomía del Futuro',
        topographicAnatomy2:
          'Transforme la Anatomía Topográfica en una experiencia interactiva y totalmente segura. Al dividir el cuerpo humano en regiones, facilitará al estudiante la comprensión de las relaciones anatómicas entre las estructuras de todos los sistemas en un segmento del cuerpo.',
        topographicAnatomy3:
          'La Anatomía Topográfica trata del estudio de la división del cuerpo humano en regiones, con el fin de facilitar la comprensión de las relaciones anatómicas entre las estructuras de todos los sistemas en un segmento determinado del cuerpo. Este método ayuda a dominar la topografía general de los órganos a partir de la percepción del funcionamiento y la ubicación de todas las piezas cercanas y relacionadas. En este módulo se incluyen las siguientes regiones anatómicas: Elementos Descriptivos del Cráneo, y las regiones anatómicas de la cabeza y el cuello, miembro superior derecho, miembro superior izquierdo, dorso, tórax, abdomen, pelvis, miembro inferior derecho y miembro inferior izquierdo.',
        systemicAnatomy: 'Visualización 3D Integral y Aprendizaje Activo',
        systemicAnatomy2:
          'Con nuestra tecnología 3D, los estudiantes exploran todos los sistemas (esquelético, muscular, nervioso, etc.) con claridad y precisión, optimizando el tiempo de estudio y mejorando la retención del contenido. Esta herramienta elimina la necesidad de gastos adicionales en piezas y modelos, garantizando la excelencia en la enseñanza sin sobrecargar el presupuesto de su institución.',
        systemicAnatomy3:
          'La Anatomía Sistémica aborda el estudio analítico de los sistemas orgánicos del cuerpo humano, estableciendo conjuntos de órganos y piezas anatómicas que desempeñan, de manera integrada, las mismas funciones en los mecanismos biológicos. Aunque cada sistema realiza una tarea distinta, todos están interconectados, garantizando el funcionamiento y la supervivencia del organismo como un todo. En este módulo se consideran los siguientes sistemas: Arterial, Articular, Digestivo, Endocrino, Esquelético, Linfático, Muscular, Nervioso, Respiratorio, Tegumentario, Urogenital y Venoso.',
        cytology: 'El Laboratorio Virtual que Optimiza Sus Costos',
        cytology2:
          'Garantice eficiencia y elimine los gastos recurrentes de laboratorio. El módulo de Citología permite explorar las estructuras celulares en detalle, con interactividad de vanguardia. Al tener acceso en línea, se elimina la necesidad de mantenimiento de microscopios, ofreciendo una herramienta de enseñanza activa que facilita el éxito del estudiante en el ciclo básico.',
        cytology3:
          'El módulo de Citología permite al usuario interactuar con dos categorías de contenidos 3D: Células y Membrana Celular. Explore las células:',
        cytology4:
          'Visualice un modelo 3D de la Membrana Celular y animaciones relacionadas con el transporte de moléculas a través de la membrana:',
        histology:
          'Reduzca los Costos de Mantenimiento y Ofrezca una Práctica Ilimitada',
        histology2:
          'El módulo de Histología funciona como un laboratorio virtual de microscopía completo, permitiendo explorar diversos tipos de tejidos, sistemas y órganos sensoriales con funciones de aumento digital e identificación de estructuras, eliminando los costos de láminas y equipos costosos.',
        histology3:
          'BioAtlas cuenta con un módulo dedicado al estudio de láminas, con más de 300 ejemplos de glándulas, órganos, tejidos y sistemas, además de láminas con patologías. También incluye una herramienta con funciones avanzadas para la visualización y el análisis de las mismas, con zoom de hasta 40x, anotaciones en las láminas, espejado, entre otras.',
        embryology: 'La Herramienta para Comprender el Desarrollo Embrionario',
        embryology2:
          'Brinde a sus estudiantes una visión completa e interactiva del desarrollo humano, desde la formación de los gametos hasta el embarazo y el estudio detallado de la placenta. Con recursos 3D inmersivos y contenidos que cubren cada etapa embrionaria y fetal, BioAtlas transforma disciplinas complejas en experiencias de aprendizaje accesibles, reduciendo los costos de laboratorio y fortaleciendo la calidad de la educación en salud de su institución.',
        embryology3:
          'Acompaña el desarrollo embrionario y fetal, desde la ovogénesis/espermatogénesis hasta el nacimiento, a través de animaciones interactivas en 3D del Período Embrionario del Desarrollo y del Período Fetal del Desarrollo.',
        physiology: 'Más Éxito para sus Estudiantes en Todos los Exámenes',
        physiology2:
          'El módulo de Fisiología detalla el funcionamiento del cuerpo humano y sus etapas de desarrollo, permitiéndole crear colecciones y estudios de caso de forma dinámica, preparando a los estudiantes para la práctica clínica y fortaleciendo la calidad de la enseñanza en su institución.',
        physiology3:
          'Explora el funcionamiento y las funciones normales del cuerpo humano a través de contenidos virtuales 3D interactivos:',
        radiology: 'Herramienta Esencial para el Razonamiento Diagnóstico',
        radiology2:
          'Prepare a sus estudiantes para la práctica clínica con el módulo de Radiología, que permite la visualización interactiva de tomografías, resonancias y radiografías, ofreciendo imágenes reales y la posibilidad de comparar exámenes. Promueva la integración de contenidos, transformando el aprendizaje en una experiencia activa y asegure que su institución ofrezca lo más avanzado en formación en salud.',
        radiology3:
          'Sistema para la visualización de imágenes DICOM con herramientas para la manipulación de estudios y casos clínicos radiológicos. Permite visualizar imágenes de diversas modalidades como:',
        pathology:
          'Desarrolle el Razonamiento Clínico y Epidemiológico de sus Estudiantes',
        pathology2:
          'El módulo de Patología, con láminas histopatológicas virtuales y modelos interactivos, facilita el estudio de diversas alteraciones morfológicas y funcionales, además de preparar a sus estudiantes para la práctica clínica. Asegure que su institución promueva el desarrollo del razonamiento clínico-epidemiológico.',
        pathology3:
          'Este módulo incluye animaciones tridimensionales que representan procesos fisiológicos no saludables (patológicos), destacando las alteraciones que ocurren en el cuerpo en estas condiciones.',
        features:
          '¡Explore los detalles del Cuerpo Humano en cualquier momento y lugar!',
        VR: 'Involucrar a estudiantes y profesores a través del entorno inmersivo de Realidad Virtual',
        multiplatform:
          'Acceso a través de cualquier navegador web, aplicación de Android o iOS',
        animations:
          'Diversos contenidos con animaciones 3D guiadas para facilitar la comprensión',
        accessControl:
          'Habilite, controle y analice el acceso de profesores y alumnos',
        integration:
          'Integre nuestro contenido en su página web a través de nuestra API',
        languages:
          'Contenido mapeado y traducido en portugués, español e inglés',
        testimonial0_0:
          'BioAtlas es una excelente herramienta para que el estudiante integre los diferentes contenidos de las ciencias biológicas y de la salud',
        testimonial0_1: 'Profesor de Fisiología Humana y Neurociencia en FMIT',
        newsletter:
          'Hable con nuestro equipo y explore BioAtlas, diseñado para apoyar e innovar en las instituciones médicas.',
        platform:
          'BioAtlas reúne en una sola plataforma anatomía humana en 3D, laboratorios virtuales, herramientas de enseñanza colaborativa y otros contenidos interactivos para ofrecer una experiencia de aprendizaje en salud inmersiva y eficiente.',
        modules:
          'Un entorno virtual con miles de posibilidades. Contenidos relacionados con la enseñanza de la anatomía humana, como el Atlas Anatómico Humano Virtual 3D, el Cadáver Virtual 3D, contenidos de Fisiología, Histología, Embriología, Citología, Simulación Médica y varios otros.',
        cadaver:
          'Tener disponible una reconstrucción 3D de un cuerpo humano real para la disección virtual y complementar la enseñanza del laboratorio de anatomía.',
        cadaver3D:
          'El cadáver virtual ilustra la anatomía de un cuerpo masculino real, con sus proporciones y estructuras bien conservadas que revelan los detalles de la morfología interna del organismo. Después de congelar y diseccionar el cuerpo, todas las partes anatómicas fueron fotografiadas y reconstruidas en 3D para facilitar la visualización y el estudio de la anatomía humana.',
        atlas3D:
          'El Atlas Humano reúne las estructuras anatómicas que representan el cuerpo humano. La mayoría de las partes son similares a las del cuerpo masculino y femenino, como los sistemas respiratorio, digestivo, muscular, articular, esquelético, linfático y endocrino. En los sistemas Urogenital, Arterial, Venoso, Nervioso y Tegumentario, algunas estructuras son diferentes, caracterizando cada sexo biológico.',
        blades:
          '¡Más de 200 láminas digitalizadas, permitiendo ampliar hasta 40x, realizar marcaciones y mucho más!',
        simulations:
          'Simulador virtual para vivir situaciones de emergencia en la práctica en la clínica médica en un entorno 100% interactivo.',
        contents1:
          'Explore el cuerpo humano en detalles a través de modelos virtuales interactivos en 3D',
        contents2:
          'Contenidos que facilitan el aprendizaje de las disciplinas de la salud humana a través de la interactividad. Integra las áreas de Ciencias Morfológicas, Ciencias Fisiológicas, Ciencias Humanas y Ciencias Sociales Aplicadas a la Salud.',
        organs:
          'Aprenda sobre la anatomía humana de manera interactiva a través de los atlas anatómicos masculino y femenino, y a través del cadáver virtual: una reconstrucción en 3D de un cuerpo humano real. El estudio macroscópico del cuerpo humano se organiza en anatomía completa, que presenta los sistemas y partes anatómicas de manera integrada; anatomía sistémica y anatomía topográfica, que estudian estructuras que forman sistemas orgánicos y regiones anatómicas.',
        cellStructure:
          'Explore las células del cuerpo humano a través de modelos 3D interactivos, explorando los orgánulos que componen los diferentes tipos de células y sus funciones. Además, un conjunto de láminas histológicas que permiten al usuario ver de manera microscópica varias estructuras corporales, como glándulas, órganos y tejidos.',
        development:
          'Estudie fisiología y embriología humana a través de contenido tridimensional virtual que exploran diferentes procesos fisiológicos y etapas del desarrollo embrionario y desarrollo fetal. Los modelos animados permiten al usuario visualizar y comprender el funcionamiento del cuerpo humano, además de demostrar las etapas de su desarrollo, desde la 4ª semana de gestación hasta su nacimiento.',
        specialties:
          'Practique el conocimiento médico de forma práctica desde diferentes perspectivas. La radiología se puede estudiar a través de imágenes DICOM, con herramientas para el manejo de casos clínicos. Conoce el módulo de patología, que utiliza modelos virtuales 3D y láminas histológicas que permiten el estudio de diversas alteraciones morfológicas y funcionales del cuerpo humano. Además, acceda al simulador virtual para experimentar situaciones de emergencia en la clínica médica en la práctica.',
        survey:
          'Te invitamos a llenar un breve formulario, es sencillo y rápido.',
        successShareCollection: 'Nuevos e-mails con acceso:',
        errorShareCollection: 'Error en los seguientes e-mails:',
        emailsWithAccess: 'E-mails con acceso:',
        usersWithAccess: 'Usuarios con acceso:',
        collectionsNotFound: '¡Descubre todo el potencial de las Colecciones!',
        rating: '¿Qué crees que se podría mejorar?',
        'features.collections':
          'Optimice su tiempo con contenido personalizado y compartible, mejorando la calidad del aprendizaje activo.',
        'features.multiplatform':
          'Garantice acceso ilimitado en cualquier dispositivo (web, tablet, móvil), aumentando el compromiso y la flexibilidad del estudiante.',
        'features.laboratory':
          'Elimine gastos en mantenimiento, modelos y materiales invirtiendo en tecnología que maximiza el presupuesto de su institución.',
        'features.support':
          'Proporcione recursos avanzados para el desarrollo de estudios de caso, fortaleciendo la investigación y la innovación en la institución.',
        'features.integration':
          'Incorpore nuestro contenido en su sitio web a través de nuestra API.',
        'features.languages':
          'Contenido mapeado y traducido al portugués, español e inglés.',
        histopathology:
          'This category includes hundreds of histological slides that show tissue and cell pathologies from various systems and anatomical regions of the human body.'
      },
      placeholders: {
        suggestion: 'Deja tu sugerencia',
        optionalSuggestion: 'Deja tu sugerencia (opcional)',
        email: 'Ingrese su correo electrónico',
        phone: 'Ingrese su teléfono',
        password: 'Ingrese su contraseña',
        newPassword: 'Crea tu contraseña',
        token: 'Ingresar código',
        name: 'Ingrese su nombre',
        lastName: 'Ingrese su apellido',
        idNumber: 'Ingrese ID (solo números)',
        search: 'Buscar',
        searchQuestion: '¿Qué contenidos quieres estudiar?',
        resultsFor: 'Resultados para',
        find: 'Búsqueda',
        country: 'Ingrese su pais',
        profession: 'Ingrese su profesión',
        countrySelect: 'Selecciona tu pais',
        professionSelect: 'Selecciona tu profesión',
        institution:
          'Ingrese el nombre de la institución o empresa a la que pertence',
        departmentSelect: 'Elige un departamento',
        message: 'Escriba su mensaje aquí',
        defaultCollectionTitle: 'Sin título',
        renameCollection: 'Agregar nombre para una nueva carpeta o elemento',
        moveCollection: 'Seleccione la carpeta que desea mover',
        shareCollection: 'Agregar e-mail con qual quiera compartir',
        createFolder: 'Agregar nombre de la nueva carpeta',
        newContent: 'Que hay de nuevo'
      },
      labels: {
        email: 'Correo electrónico',
        password: 'Contraseña',
        newPassword: 'Nueva contraseña',
        oldPassword: 'Contraseña actual',
        repeatPassword: 'Repetir contraseña',
        token: 'Ingrese el código recibido',
        firstName: 'Nombre',
        lastName: 'Apellido',
        fullName: 'Nombre completo',
        guardianName: 'Nombre del Tutor Legal',
        guardianIdNumber: 'ID del Tutor Legal',
        minorName: 'Nombre del menor',
        country: 'Pais',
        profession: 'Profesión',
        institution: 'Nombre de la institución o empresa',
        department: '¿Con qué departamento quieres hablar?',
        isAfya: '¿Su institución pertenece al Grupo Afya?',
        message: 'Mensaje',
        phone: 'Teléfono',
        mobile: 'Teléfono celular',
        language: 'Idioma',
        pt: 'Português',
        es: 'Español',
        en: 'English',
        undefined: 'Indefinido',
        description: 'Descripción',
        details: 'Detalles',
        forbidden: 'Módulo no liberado',
        account: 'Cuenta',
        personalAccount: 'Cuenta Personal',
        corporateAccount: 'Cuenta Corporativa',
        legal: 'Jurídico',
        useTerms: 'Condiciones de Uso',
        politics: 'Política de Privacidad',
        cookies: 'Política de Cookies',
        requests: 'Órdenes del titular',
        dragFile: 'Arrastrar o',
        uploadFile: 'sube tu archivo aquí',
        availability: 'Disponible:',
        contactWhats: '+55 11 96340-0766',
        contactEmail: 'comercial@medicalharbour.com',
        newModule: 'Nuevo módulo',
        new: 'Nuevo',
        updated: 'Actualizado',
        newContent: 'Nuevo contenido',
        step: 'Paso',
        renameCollection: 'Nombre de carpeta o elemento',
        moveCollection: 'Mover para',
        shareCollection: 'Compartir carpeta o elemento',
        createdAt: 'Creado el',
        folderName: 'Nombre de la carpeta',
        directLink: 'Enlace directo',
        selectFolder: 'Ubicación del contenido',
        '3d_contents': 'Contenido 3D',
        slides: 'Láminas',
        shearchFolder: 'Buscar carpetas',
        addedAt: 'añadido el',
        myCollection: 'Mi colección',
        myCollections: 'Mis colecciones',
        collectionsSharedWithMe: 'Compartidos conmigo',
        afyaCollections: 'Colecciones Afya',
        order: 'Orden',
        recentsOrder: 'Más recientes',
        alphabeticalOrder: 'Alfabética',
        contentTypeOrder: 'Tipo',
        filter: 'Filtrar',
        type: 'Tipo',
        mostRecent: 'Más reciente',
        recentViewedContents: 'Contenidos accedidos recientemente',
        weeklyTopContents: 'Más accedidos de la semana',
        nextReleasesContents: 'Próximos lanzamientos',
        notifyActivated: '¡Advertencia activada!',
        notifyRelease: 'Avísame cuando se publique'
      },
      buttons: {
        signup: 'Registrar',
        signin: 'Iniciar sesión',
        enter: 'Acceder',
        save: 'Guardar',
        cancel: 'Cancelar',
        return: 'Regresar',
        exit: 'Salir',
        edit: 'Editar',
        update: 'Actualizar',
        view: 'Visualizar',
        subscribe: 'Suscribir',
        send: 'Enviar',
        adjust: 'Ajustar',
        remember: 'Recuérdame',
        sendData: 'Enviar Datos',
        sendToken: 'Enviar correo electrónico para restablecer',
        resendToken: 'Reenviar código',
        resetPassword: 'Restablecer contraseña',
        changePassword: 'Cambiar Contraseña',
        changeProfile: 'Cambiar Datos',
        changeLanguage: 'Cambiar Idioma',
        changeAvatar: 'Cambiar Foto',
        deleteAccount: 'Borrar Cuenta',
        confirmDelete: 'Borrar de todos modos',
        cancelDelete: 'No borres',
        viewPlan: 'Consultar todos los servicios de su Plan',
        finalizeAccount: 'Finalizar Registro',
        navigation: 'Nociones de Navegación',
        shortcuts: 'Atajos de Teclado',
        demo: 'Solicitar una demostración',
        discover: 'Quiero conocer el BioAtlas',
        openNewTab: 'El enlace se abre en una nueva pestaña.',
        getNews: 'Recibir noticias',
        knowMore: 'Más información',
        knowContent: '$t(buttons.knowMore) sobre nuestro contenido',
        knowModules: '$t(buttons.knowMore) sobre nuestros módulos',
        knowCadaver: '$t(buttons.knowMore) sobre el cadáver virtual',
        askDemo: 'Solicita ahora una demostración para tu institución.',
        askDemoNow: 'Solicita ahora la demo para tu institución',
        surveyNo: 'No gracias',
        surveyYes: 'Hagamos el reto',
        seeContent: 'Visualizar contenido',
        keepReading: 'continuar leyendo en el contenido',
        relatedContent: 'Contenidos Relacionados',
        bibliography: 'Bibliografía',
        share: 'Compartir',
        rename: 'Renombrar',
        duplicate: 'Duplicar',
        move: 'Mover',
        delete: 'Eliminar',
        createFolder: 'Crear carpeta',
        sendFeedback: 'Enviar feedback',
        seeAll: 'ver todo',
        emailTab: 'Correo electrónico',
        linkTab: 'Enlace',
        copyLink: 'Copiar enlace',
        linkCopied: '¡Copiado!',
        firstSteps: 'Pinitos',
        navigationAndShortcuts: 'Navegación y accesos directos',
        addNewEmails: 'Agregar nuevos e-mails',
        close: 'Cerrar',
        manageAccess: 'Administrar el acceso',
        addToCollection: 'Agregar a mi colección',
        add: 'Añadir',
        startNow: 'Comenzar ahora'
      },
      messages: {
        conjunction: 'y',
        separator: 'o',
        optional: 'opcional',
        agreeTerms1: 'Al registrarme, acepto que he leído y aceptado las',
        agreeTerms2: 'Acepto que he leído y aceptado las',
        agreeTermsMinorS:
          'Soy mayor de 18 años y soy consciente de las responsabilidades.',
        agreeTermsMinorL:
          'Soy menor de 18 años y mi tutor legal autoriza a Medical Harbor a recopilar mis datos personales a efectos de comunicaciones electrónicas de ofertas y servicios (SMS, mensajería instantánea, teléfono, correo electrónico) de acuerdo con la $t(labels.politics).',
        validationSent:
          '¡Le enviamos un correo electrónico para validar su registro!',
        contactAdmin: '¡Póngase en contacto con el administrador del sistema!',
        accountReady: '¡Su acceso a BioAtlas está activo!',
        dataSharing: 'Acepte el intercambio de datos para ofertas de productos',
        notifications:
          '¿Acepta recibir notificaciones por SMS, Whatsapp o correo electrónico?',
        deleteQuestion:
          '¿Está seguro de que desea eliminar permanentemente su cuenta?',
        deleteReminder1:
          'Eliminar su cuenta de BioAtlas es una acción permanente y no se puede deshacer.',
        deleteReminder2:
          'Una vez que elimine su cuenta, no podrá volver a iniciar sesión en la aplicación y cualquier modelo 3D que haya creado y guardado en su biblioteca se eliminará de nuestra base de datos de forma permanente y no se podrá restaurar.',
        trialWarning:
          'Estás usando la versión de prueba. Todavía falta {{count}} día.',
        trialWarning_plural:
          'Estás usando la versión de prueba. Todavía quedan {{count}} días.',
        trialUpgrade: 'Obtener la versión PRO.',
        noContent: 'No se encontró contenido para',
        newContent: 'Nuevo contenido que te puede interesar',
        noAccount: '¿Aún no tienes una cuenta?',
        gotAccount: '¿Ya tienes una cuenta?',
        passwordsDontMatch: '¡Las contraseñas deben coincidirse!',
        notYetValidated:
          '¡Aún no ha validado su registro por el correo electrónico que se envió!',
        notYetConfirmed:
          'Aún no has confirmado tu registro. Consultar su correo electrónico.',
        confirmAccount: 'Confirme su cuenta de BioAtlas',
        notYetConfirmed1: 'Antes de cambiar su contraseña,',
        notYetConfirmed2: 'Antes de iniciar sesión,',
        notYetConfirmed3: 'confirme su cuenta por correo electrónico.',
        notYetConfirmed4:
          'No olvides revisar también tu casilla de correo no deseado, ¿de acuerdo?',
        checkData: 'Revisa tus datos e intenta de nuevo',
        loginInvalid: 'Nombre de usuario y/o contraseña no válidos',
        userNotFound: 'Usuario no encontrado',
        wrongPassword: 'La contraseña actual es incorrecta',
        tooManyRequests:
          'Ha ralizado demasiadas solicitudes. Espere un momento y vuelve a intentarlo.',
        tooManyFailedAttempts: 'Has fallado en varios intentos',
        tooManyAttempts: 'Has excedido el límite de intentos',
        tokenSent: 'Código enviado al correo electrónico: {{email}}',
        passwordChanged: '¡Contraseña cambiada con éxito!',
        tokenInvalid:
          'El código proporcionado no es válido. Vuelva a solicitar un código.',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        tryAgain:
          '¡Hubo un problema al enviar tu información, inténtalo de nuevo!',
        partialSuccessData:
          'Sus datos se han actualizado con éxito, sin embargo, hubo un problema al cargar su foto.',
        partialSuccessImg:
          'Su foto se actualizó con éxito, sin embargo, hubo un problema al enviar sus datos.',

        requiredField: 'Campo obligatorio',
        invalidEmail: 'Introduzca un correo electrónico válido',
        emailExists:
          'Ya existe una cuenta con el correo electrónico proporcionado',
        phoneExists: 'Este número de teléfono ya está registrado',
        phoneTooShort: 'Número de teléfono no válido.',
        idTooShort: 'Número de identificación no válido.',
        dataUpdated: '¡Datos actualizados con éxito!',
        collectionDeleted: 'Colección eliminada con éxito!',
        alreadySignedUp:
          '¡Ya se ha registrado, inicie sesión con su nombre de usuario y contraseña!',
        invalidLink:
          '¡Este enlace no es válido, comuníquese con su administrador!',
        multipleImages: 'Envía solo un archivo',
        imageType:
          'Este tipo de archivo no es compatible. Extensiones válidas: {{support}}',
        imageSize:
          '¡El archivo es demasiado grande! ({{size}}) El tamaño máximo de carga es de {{limit}}.',
        agreement:
          'Debes aceptar las $t(labels.useTerms) y la $t(labels.politics)',
        guardianData:
          'Como eres menor de edad, necesitas introducir los $t(titles.guardianData)',
        unreachable:
          'Nuestro servidor está experimentando dificultades técnicas. Vuelve a intentarlo más tarde.',
        accessDenied: 'Inicie sesión de nuevo.',
        unverifiedEmail: 'Error: correo electrónico no verificado',
        autoLogin: 'Te estamos iniciando seción.',
        copySuccess: '¡Copiado en el portapapeles!',
        copyError: '¡Error al copiar!',
        unexistingModule: 'Contenido no existe',
        unavailable: 'Contenido no disponible',
        betterExp:
          'Para una mejor experiencia, acceda a nuestra aplicación o a la versión desktop',
        desktop: 'computadora',
        appAvailable: 'Descargue la aplicación BioAtlas en las tiendas',
        support1: 'Póngase en contacto com nuestro',
        support2: 'equipo de soporte',
        crash: 'Algo salió mal con BioAtlas. $t(messages.support1)',
        appDenied:
          'Vimos que no tienes accesso al BioAtlas. $t(messages.support1)',
        contactSuccess1: '¡Hola! ¡Acabamos de recibir tu mensaje!',
        contactSuccess2:
          'Estamos muy contentos de saber que quieres hablar con nosotros. Muchas gracias por su interés en BioAtlas.',
        contactSuccess3:
          'Estamos revisando su mensaje y en breve nos pondremos en contacto con usted para responder a sus preguntas y comentarios.',
        whichContents: 'Cúales capítulos accesarás:',
        errorCollection:
          'Lo siento, ocurrió un error al intentar obtener tus colecciones',
        emptyCollections:
          'Parece que aún no tienes ninguna colección. Elige cualquier modelo 3D, personalízalo a tu manera y guarda ;)',
        emptyCollectionsMobile:
          'Parece que aún no tienes ninguna colección. Accede a tu aplicación para ver tus colecciones.',
        emptyCollectionsShared:
          'Aún no se ha compartido ninguna colección contigo. Cuando alguien comparta una, aparecerá aquí',
        collectionRenamed: '¡Colección renombrada exitosamente!',
        folderRenamed: 'Carpeta renombrada exitosamente!',
        collectionMoved: '¡Colección movida exitosamente!',
        collecionDeleted: '¡Colección excluída exitosamente!',
        collecionShared: '¡Colección compartida exitosamente!',
        collectionUnshared: '¡Colección removida del usuario exitosamente!',
        collectionDuplicated: '¡Colección duplicada exitosamente!',
        collectionFolderCreated: '¡Carpeta creada exitosamente!',
        collectionFolderDuplicateErr: 'Carpeta con este nombre ya existe',
        demoPopUpText1: 'Tienes ',
        demoPopUpTextDays: 'día ',
        demoPopUpTextDaysPlural: 'días ',
        demoPopUpTextMonths: 'mes ',
        demoPopUpTextMonthsPlural: 'meses ',
        demoPopUpText2: 'de acceso demo',
        demoPopUpText3:
          ', tu opinión sobre nuestra plataforma es muy importante.',
        demoExpiredText:
          'Su licencia de demostración ha caducado. Por favor contacte nuestro soporte.',
        demoExpiredBtn: 'Chatea con nuestro equipo',
        errorInputShared: 'No es posible compartir la colección en este email',
        by: 'De',
        deleteCollectionMsgSingular:
          'Al eliminar esta carpeta también se eliminarán las siguientes colecciones o carpetas:',
        deleteCollectionMsgPlural:
          'Al eliminar esta carpeta también se eliminarán las siguientes colecciones o carpetas:',
        folderNotFound: 'Carpeta no encontrada',
        newContentTitle: 'Consulta las últimas novedades de BioAtlas',
        newContentSubtitle: 'Nueva herramienta para guardar tus colecciones',
        newContentText:
          'Ahora puedes crear una colección personalizada de contenido 3D. Con BioAtlas, puedes guardar estos modelos, organizarlos en carpetas y compartirlos de forma sencilla y rápida con tus amigos y alumnos.',
        newContentClose: 'Cerrar',
        to: 'para',
        thankYouRating: 'Gracias por tu valoración',
        pickRateError:
          'Por favor, elija una calificación para este contenido o cambie su calificación / comentario anterior antes de enviarlo.',
        shareCollectionErrorTitle: 'Error al obtener la colección',
        shareCollectionErrorText:
          'No fue posible acceder a la colección que fue compartida contigo. Serás redirigido a la página de inicio',
        expiredCollectionLinkErrorTitle: 'Enlace expirado',
        expiredCollectionLinkErrorText:
          'Obtén un nuevo enlace para acceder a esta colección. Serás redirigido a la página de inicio',
        clipboardPermissionsErrorTitle: 'No fue posible copiar el enlace',
        clipboardPermissionsErrorText:
          'Verifica los permisos del sitio para el portapapeles e inténtalo de nuevo',
        saveCollectionSuccessTitle: 'Contenido añadido',
        saveCollectionSuccessText:
          'El contenido se ha añadido a tu colección con éxito',
        saveCollectionErrorTitle: 'Error al guardar contenido en colecciones',
        saveCollectionErrorText:
          'No se pudo guardar el contenido en este momento. Inténtalo de nuevo más tarde',
        lockedItem: 'Contenido institucional bloqueado',
        lockedFolderNoCreate:
          'No puedes crear carpetas dentro de colecciones institucionales.'
      },
      swal: {
        success: 'Éxito',
        warning: 'Atención',
        error: '¡Ha ocurrido un problema!',
        access: 'No tienes accesso',
        crash: '¡Ups!'
      },
      banner: {
        title: '¿Sabías?',
        curiosity1:
          'El cerebro humano tiene aproximadamente 86 mil millones de neuronas. Solo el 19% de ellos están ubicados en la corteza cerebral, mientras que el cerebelo contiene alrededor del 80%. El resto se encuentra en el tronco cerebral.',
        curiosity2:
          'El cuerpo humano brilla en la oscuridad. Este proceso consiste en la emisión de biofotones, caracterizados por reacciones químicas que emiten pequeñas cantidades de luz en nuestras células. No notamos este brillo a simple vista ya que la intensidad es mucho más débil de lo que podemos detectar.'
      },
      alts: {
        load: 'Cargando animación',
        logo: 'Logotipo de BioAtlas',
        eye: 'Icono de ojo para habilitar la visibilidad de la contraseña',
        avatar: 'Foto de perfil de usuario',
        edit: 'Editar icono',
        computer:
          'Imagen de una computadora que le advierte que ha llegado un correo electrónico',
        check: 'Animación de un icono de cheque',
        folder: 'Carpeta',
        home: 'Inicio',
        playstore: 'Imagen de Playstore',
        appstore: 'Imagen de Appstore'
      },
      modules: {
        cytology: 'Citología',
        transports: 'Transporte en la Membrana',
        histology: 'Histología',
        systemicAnatomy: 'Anatomía Sistémica',
        topographicAnatomy: 'Anatomía Topográfica',
        completeAnatomy: 'Anatomía Completa',
        physiology: 'Fisiología',
        embryology: 'Embriología',
        radiology: 'Radiología'
      },
      categories: {
        all: 'Todos',
        tissues: 'Tejidos',
        systems: 'Sistemas',
        organs: 'Órganos Sensoriales',
        atlas: 'Atlas de Anatomía Humana',
        atlas2: 'Atlas Anatómico',
        cadaver: 'Cadáver Virtual'
      },
      improvements: {
        exam_quality: 'Calidad del examen',
        exam_report: 'Informe del examen',
        features: 'Funcionalidades',
        usability_navigation: 'Usabilidad/Navegación',
        other_reason: 'Otro motivo (comente abajo)',
        text: 'Texto',
        slide_quality: 'Calidad de la lámina',
        information_consistency: 'Coherencia de la información',
        sample: 'Muestra',
        structure_identification: 'Identificación de las estructuras',
        morphology: 'Morfología',
        loading: 'Carga',
        content_depth: 'Profundización del contenido'
      },
      subCategories: {
        epithelial: 'Tejido Epitelial',
        connective: 'Tejido Conectivo',
        circulatory: 'Circulatorio',
        articular: 'Articular',
        digestive: 'Digestivo',
        endocrine: 'Endocrino',
        skeletal: 'Esquelético',
        integumentary: 'Tegumentario',
        lymphoid: 'Linfático',
        muscular: 'Muscular',
        nervous: 'Nervioso',
        respiratory: 'Respiratorio',
        urogenital: 'Urogenital',
        male: 'Masculino',
        female: 'Femenino'
      },
      helpers: {
        rotateMouse:
          'Mantenga presionado el botón izquierdo del mouse y muévase para rotar el objeto',
        moveMouseBlade:
          'Mantenga presionado el botón izquierdo del mouse y arrastre para mover la cuchilla',
        moveMouseModel:
          'Mantenga presionado el botón derecho del mouse para mover el objeto en la pantalla',
        selectMouse:
          'Haga clic izquierdo una vez para seleccionar una estructura',
        zoomMouse:
          'Use el botón de desplazamiento del mouse para acercar o alejar',
        textboxMouse:
          'Presione shift en el teclado, haga clic y arrastre el botón izquierdo del mouse',
        cameraKeyboard:
          'Use la tecla (W) para moverse hacia arriba, la tecla (S) para moverse hacia abajo, la tecla (A) para moverse hacia la izquierda y la tecla (D) para moverse hacia la derecha',
        rotateKeyboard:
          'Use la tecla (↑) para girar hacia arriba, la tecla (↓) para girar hacia abajo, la tecla (←) para girar hacia la izquierda y la tecla (→) para girar hacia la derecha',
        zoomKeyboard: 'Use las teclas + y - para hacer zoom',
        moveKeyboard: 'Usa las teclas de flecha para mover la cuchilla',
        rotatePad:
          'Mantén presionado el botón izquierdo del panel táctil y muévelo para rotar',
        movePad:
          'Mantenga presionado el botón derecho del panel táctil y mueva la cámara del objeto',
        zoomPad: 'Haga clic izquierdo una vez para seleccionar una estructura'
      },
      home: {
        banner: {
          title:
            'Contenido Virtual Interactivo 3D para la Enseñanza en el Área de la Salud',
          subtitle:
            'Explore contenido digital interactivo en 3D para la Enseñanza del ciclo básico de salud a través de un navegador web, una aplicación Android/iOS y gafas de realidad virtual'
        },
        specs: {
          title:
            '¡Explore los detalles del cuerpo humano en cualquier momento y en cualquier lugar!',
          item1: 'Acesso Multiplataforma',
          text1:
            'Acceda a través de cualquier navegador web, aplicación de Android o iOS, no se requieren complementos, no se requiere instalación',
          item2: 'Control de Acceso',
          text2:
            'Habilite, controle y analice el acceso de profesores y alumnos',
          item3: 'Disponible en 3 idiomas',
          text3: 'Contenido mapeado y traducido al portugués, español e inglés',
          item4: 'Integración',
          text4:
            'Embárcate en nuestro contenido en su sitio web a través de nuestra API',
          item5: 'Animaciones Interactivas 3D',
          text5:
            'Contenido diverso con animaciones 3D guiadas para facilitar la comprensión',
          item6: 'Realidad Virtual 3D',
          text6:
            'Involucre a estudiantes y profesores a través del entorno inmersivo de Realidad Virtual'
        },
        minibanner: 'Reduzca los costos del laboratorio de anatomía',
        allInOne: {
          title:
            'Una suite multiplataforma para acceder a una Biblioteca Digital Interactiva de contenidos 3D para la Enseñanza en Salud',
          text: 'BioAtlas es una solución que se adapta a diversas herramientas tecnológicas del mercado y permite navegar por Contenidos Digitales Interactivos 3D para la salud utilizando cualquier navegador web o aplicación móvil Android o iOS y Gafas de Realidad Virtual.'
        },
        teaser: 'Conozca un poco más sobre BioAtlas',
        dashboard: {
          title:
            'Dashboard con datos para acompañamiento de indicadores de uso',
          subtitle:
            'Más inteligencia para monitorear el uso del sistema y los resultados a su favor',
          text1:
            'Analice el uso, el compromiso, la performance y otras métricas clave para mejorar el aprendizaje',
          text2: 'Obtenga información de las interacciones de los usuarios'
        },
        quotes: {
          text1:
            'BioAtlas es una excelente herramienta para que el estudiante integre los diferentes contenidos de las ciencias biológicas y de la salud',
          position: 'Profesor de Fisiología Humana y Neurociencia en FMIT'
        },
        carousel: {
          collections: {
            title:
              '¿Quieres compartir tus estudios personalizados de forma sencilla y organizada?',
            description: '¡Crea una colección y compártela con quien quieras!',
            button: 'Acceder a colecciones'
          },
          suggestions: {
            title: '¿No encontraste lo que necesitabas?',
            description:
              'Tu sugerencia puede inspirar los próximos contenidos de la plataforma.',
            button: '¡Vamos!'
          }
        },
        conclusion:
          'Conozca BioAtlas, sus posibilidades y asegure el conocimiento de la Salud de su Institución en cualquier escenario de aprendizaje.',
        'footerBannerSubtitle.1': 'BioAtlas también está en tu bolsillo.',
        'footerBannerSubtitle.2':
          '¡Descarga la app y lleva tus estudios contigo!'
      },
      contentTypes: {
        unity: 'Contenido 3D',
        slide: 'Láminas',
        dicom: 'Imágenes'
      },
      contents: {
        banner: {
          title:
            'Explore el cuerpo humano en detalle a través de modelos virtuales interactivos en 3D',
          subtitle:
            'BioAtlas te permite navegar por el cuerpo humano de forma virtual totalmente interactiva utilizando cualquier navegador web, smartphone o gafas de Realidad Virtual.',
          obs: '*Está disponible en 3 idiomas: portugués, inglés y español'
        },
        systems: {
          title: 'Sistemas del cuerpo humano',
          completeAnatomy: {
            text1:
              'tiene más de 2500 estructuras etiquetadas de todos los sistemas anatómicos del cuerpo humano. Este módulo está separado en modelos masculino y femenino y está organizado según sus 12 sistemas anatómicos y 9 regiones.',
            text2:
              'es una reconstrucción en 3D de un cuerpo humano real que fue donado para investigación*. Se congeló, se dividió en 1878 partes y se fotografió con equipos de muy alta resolución. El cadáver virtual ha conservado los colores, está segmentado y mapeado para una visualización completa.',
            obs1: '*La versión 3D en Realidad Virtual - VR - es una forma inmersiva para  entender y comprender el cuerpo humano a un paso del metaverso.',
            obs2: '*Conoce más sobre el Proyecto Visible Human'
          },
          topographicAnatomy: {
            text: 'Navegue por los Elementos Descriptivos del Cráneo y las regiones anatómicas: cabeza y cuello, miembro superior derecho, miembro superior izquierdo, espalda, tórax, abdomen, pelvis, miembro inferior derecho y miembro inferior izquierdo.'
          },
          systemicAnatomy: {
            text: 'Sistemas anatómicos: tegumentario, muscular, esquelético, articular, nervioso, linfático, digestivo, respiratorio, arterial, venoso, endocrino y urogenital.'
          },
          physiology: {
            text: 'Explore el funcionamiento normal y las funciones del cuerpo humano a través de contenido virtual interactivo en 3D:',
            item1: 'Ciclo del corazón',
            item2: 'Contracción de la fibra muscular',
            item3: 'Generación y Conducción del Potencial de Acción',
            item4: 'Hematosis',
            item5: 'Transmisión sináptica',
            item6: 'Ventilación pulmonar'
          }
        },
        cellStructure: {
          title: 'Estructura celular y microanatomía',
          cytology: {
            title: 'Citología 3D',
            text: 'El módulo de Citología permite al usuario interactuar con dos categorías de contenido 3D: Células y Membrana celular. Navega por las células: Célula Eucariota de origen animal, Célula Sanguínea, Neurona y Fibra Muscular. Visualice un modelo de membrana celular en 3D con cinco animaciones relacionadas con el transporte de moléculas a través de la membrana:',
            item1: 'Difusión simple',
            item2: 'Difusión facilitada',
            item3: 'Bomba de sodio y potasio',
            item4: 'Co-transporte',
            item5: 'Contratransporte'
          },
          histology: {
            text: 'BioAtlas dispone de un módulo dedicado al estudio de láminas de glándulas, órganos, tejidos y sistemas, y láminas con patologías. Además de disponer de una herramienta con recursos para su visualización y análisis.'
          }
        },
        development: {
          title: 'Desarrollo humano',
          embryology: {
            text: 'Realice un seguimiento del desarrollo embrionario y fetal, desde la quarta semana de gestación hasta el nacimiento, a través de animaciones 3D interactivas.'
          }
        },
        specialties: {
          title: 'Especialidades medicas',
          radiology: {
            text: 'Sistema de visualización de imágenes DICOM con herramientas para el manejo de casos y estudios clínicos radiológicos. Te permite visualizar imágenes de diferentes modalidades como tomografías computarizadas, resonancias magnéticas, radiografías, entre otras, a través del navegador web.'
          }
        },
        collections: {
          notFound:
            'Mira el video a continuación y descubre, en la práctica, cómo cada funcionalidad puede transformar tu forma de estudiar y explorar los contenidos.'
        },
        conclusion:
          'Póngase en contacto para obtener información sobre BioAtlas'
      },
      onboarding: {
        steps: {
          step1:
            'Paso 1: ¡Queremos conocerte mejor! ¿Con qué área de la salud te identificas más?',
          step2: 'Paso 2: Especialidad o Interés Principal',
          step3: 'Paso 3: Momento en la carrera o formación',
          step4: 'Paso 4: Objetivo principal en BioAtlas',
          step5: 'Paso 5: Preferencia de aprendizaje',
          step6: 'Paso 6: Tiempo semanal disponible'
        },
        auxiliaryTexts: {
          step1: 'Elige solo un área.',
          step2:
            '¿Cuál es tu especialidad o área de interés? (Si no tienes una, puedes elegir "Interés general")',
          step3: '¿En qué etapa de tu viaje te encuentras?',
          step4: '¿Qué buscas en la plataforma?',
          step5: '¿Cómo prefieres aprender?',
          step6: '¿Cuánto tiempo dedicas a estudiar cada semana?'
        },
        buttons: {
          skip: 'Omitir y hacer después',
          continue: 'Continuar',
          finish: 'Finalizar y acceder a BioAtlas',
          back: 'Volver'
        },
        stepBar: {
          of: '{{step}} de {{totalSteps}}'
        },
        healthAreas: {
          medicine: 'Medicina',
          nursing: 'Enfermería',
          pharmacy: 'Farmacia',
          physiotherapy: 'Fisioterapia',
          nutrition: 'Nutrición',
          biomedicine: 'Biomedicina',
          dentistry: 'Odontología',
          physical_education: 'Educación Física',
          others: 'Otros'
        },
        specialties: {
          medicine: {
            clinical_medicine: 'Medicina Clínica',
            pediatrics: 'Pediatría',
            general_surgery: 'Cirugía General',
            gynecology_obstetrics: 'Ginecología / Obstetricia',
            cardiology: 'Cardiología',
            orthopedics: 'Ortopedia',
            dermatology: 'Dermatología',
            emergency: 'Emergencias',
            geriatrics: 'Geriatría',
            ophthalmology: 'Oftalmología',
            pathology: 'Patología',
            general_interest: 'Interés General',
            others: 'Otros'
          },
          nursing: {
            medical_surgical_nursing: 'Enfermería Médico-Quirúrgica',
            pediatric_nursing: 'Enfermería Pediátrica',
            obstetric_nursing: 'Enfermería Obstétrica',
            mental_health_nursing: 'Enfermería en Salud Mental',
            emergency_nursing: 'Enfermería de Emergencias',
            geriatric_nursing: 'Enfermería Geriátrica',
            public_health_nursing: 'Enfermería en Salud Pública',
            occupational_nursing: 'Enfermería del Trabajo',
            others: 'Otros'
          },
          pharmacy: {
            hospital_pharmacy: 'Farmacia Hospitalaria',
            clinical_pharmacy: 'Farmacia Clínica',
            clinical_analysis: 'Análisis Clínicos',
            pharmaceutical_industry: 'Industria Farmacéutica',
            community_pharmacy: 'Farmacia Comunitaria',
            compounding_pharmacy: 'Farmacia de Preparación',
            toxicology: 'Toxicología',
            pharmacovigilance: 'Farmacovigilancia',
            cosmetology: 'Cosmetología',
            others: 'Otros'
          },
          physiotherapy: {
            neurological_physiotherapy: 'Fisioterapia Neurológica',
            respiratory_physiotherapy: 'Fisioterapia Respiratoria',
            cardiovascular_physiotherapy: 'Fisioterapia Cardiovascular',
            dermatofunctional_physiotherapy: 'Fisioterapia Dermato-funcional',
            geriatric_physiotherapy: 'Fisioterapia Geriátrica',
            pediatric_physiotherapy: 'Fisioterapia Pediátrica',
            women_health_physiotherapy: 'Fisioterapia en Salud de la Mujer',
            sports_physiotherapy: 'Fisioterapia Deportiva',
            others: 'Otros'
          },
          nutrition: {
            clinical_nutrition: 'Nutrición Clínica',
            sports_nutrition: 'Nutrición Deportiva',
            public_health_nutrition: 'Nutrición en Salud Pública',
            maternal_child_nutrition: 'Nutrición Materno-Infantil',
            geriatric_nutrition: 'Nutrición Geriátrica',
            hospital_nutrition: 'Nutrición Hospitalaria',
            others: 'Otros'
          },
          biomedicine: {
            clinical_analysis: 'Análisis Clínicos',
            molecular_biology: 'Biología Molecular',
            radiology_diagnostic_imaging: 'Radiología / Diagnóstico por Imagen',
            microbiology: 'Microbiología',
            immunology: 'Inmunología',
            hematology: 'Hematología',
            blood_bank_hemotherapy: 'Banco de Sangre / Hemoterapia',
            genetics: 'Genética',
            parasitology: 'Parasitología',
            aesthetics: 'Estética',
            others: 'Otros'
          },
          dentistry: {
            dental_aesthetics_restorative:
              'Odontología Estética / Restauradora',
            endodontics: 'Endodoncia',
            periodontics: 'Periodoncia',
            oral_maxillofacial_surgery: 'Cirugía Bucomaxilofacial',
            orthodontics: 'Ortodoncia',
            pediatric_dentistry: 'Odontopediatría',
            dental_prosthetics: 'Prótesis Dental',
            dental_radiology: 'Radiología Odontológica',
            oral_pathology: 'Patología Bucal',
            others: 'Otros'
          },
          physical_education: {
            school_physical_education: 'Educación Física Escolar',
            sports_training: 'Entrenamiento Deportivo',
            physical_activity_health: 'Actividad Física y Salud',
            recreation_leisure: 'Recreación y Ocio',
            bodybuilding_conditioning: 'Musculación / Acondicionamiento',
            rehabilitation_therapeutic_exercise:
              'Rehabilitación / Ejercicio Terapéutico',
            workplace_gymnastics: 'Gimnasia Laboral',
            psychomotricity: 'Psicomotricidad',
            special_populations_physical_activity:
              'Actividad Física para Poblaciones Especiales',
            others: 'Otros'
          },
          others: {
            general_interest: 'Interés General',
            others: 'Otros'
          }
        },
        academicLevels: {
          student: 'Estudiante de pregrado',
          resident: 'Residente / Posgrado',
          professor: 'Profesor / Investigador'
        },
        semesters: {
          '1-2': '1º - 2º semestre',
          '3-4': '3º - 4º semestre',
          '5-6': '5º - 6º semestre',
          '7+': '7º+ semestre'
        },
        objectives: {
          study: 'Seguir materias de la universidad',
          pass_exams: 'Aprobar exámenes (residencia, concurso)',
          practical: 'Aprender habilidades prácticas',
          personal_interest: 'Explorar nuevos contenidos por interés personal'
        },
        learningPreferences: {
          videos: 'Videos',
          summaries: 'Resúmenes organizados',
          articles: 'Artículos',
          clinical_cases: 'Casos clínicos y ejercicios',
          audios: 'Podcasts y audio-clases',
          study_group: 'Grupos de estudio y foros'
        },
        weeklyTime: {
          '3h': 'Poco tiempo (Hasta 3h/semana)',
          '4-7h': 'Algunas horas (4 a 7h/semana)',
          '8h': 'Mucho tiempo (8h o más)'
        },
        subtexts: {
          healthAreaOthers:
            '¿Quieres explorar otras áreas de la salud? ¡Escribe aquí tus preferencias!',
          specialtyOthers:
            '¿Quieres explorar otras especialidades? ¡Escribe aquí tus preferencias!',
          semesterTitle: 'Año / Semestre:'
        },
        tempContent: {
          stepContent: 'Contenido del {stepText}',
          tempArea:
            'Esta es un área temporal para el contenido específico de cada etapa.'
        },
        editBanner: {
          title: '¿Qué tal completar tu perfil?',
          subtitle: 'Con esto, entendemos mejor tus intereses y preferencias.',
          editProfile: 'Editar mi perfil',
          letsGo: 'Vamos'
        }
      },
      integration: {
        banner: {
          title: 'Agregue interactividad BioAtlas 3D a su contenido',
          subtitle:
            'Dé vida a su proyecto de atención médica agregando su marca a BioAtlas o incorporando nuestras animaciones, piezas virtuales interactivas a través de la integración API de BioAtlas.'
        },
        api: {
          label: 'API BioAtlas',
          title:
            'Contenido 3D de BioAtlas en su proyecto a través de nuestra API',
          subtitle:
            'Construya una experiencia interactiva virtual 3D en su proyecto relacionado con la anatomía u otras disciplinas relacionadas con el ciclo básico en Salud. El contenido de BioAtlas se puede integrar fácilmente en su sitio web, contenido digital, LMS o proyecto digital a través de la API de BioAtlas.'
        },
        institutions: {
          label: 'Instituciones',
          title: 'BioAtlas para su institución',
          item1: 'Farmacéutico',
          item2: 'Universidades',
          item3: 'Hospitales',
          item4: 'Editores'
        },
        whiteLabel: {
          label: 'White Label',
          title: 'BioAtlas con la marca de tu Institución',
          subtitle:
            'BioAtlas cuenta con una solución “Private Label”, que le permite marcar su Institución, convirtiéndola en una solución 100% personalizada.'
        }
      },
      contactPage: {
        form: {
          step: 'Paso',
          of: 'de',
          select: 'Selecione',
          title: 'Solicite ahora su demostración gratuita de BioAtlas',
          previousButton: 'Volver',
          nextButton: 'Continuar',
          submitButton: 'Enviar solicitud',
          businessEmail: 'Ingrese su correo electrónico comercial',
          allowReceiveEmails: 'Acepto recibir novedades por correo electrónico',
          fullName: '¡Genial! Ahora, ingrese su nombre completo',
          phone: '¡Muy bien! Ahora, ingrese su número de teléfono / WhatsApp',
          institutionName: '¿Cuál es el nombre de su institución?',
          profession: '¿Cuál es su cargo o profesión?',
          professions: {
            coordinator: 'Coordinador(a) del Curso',
            professor: 'Profesor(a)',
            student: 'Estudiante',
            others: 'Otros'
          },
          privacyPolicy: {
            text: 'Al enviar mis datos personales, autorizo a BioAtlas a recopilar, procesar y almacenar mi información de acuerdo con el Aviso de Privacidad, como se describe en el ',
            link: 'Aviso de Privacidad de BioAtlas'
          },
          success: {
            header: '¡Su solicitud de demostración ha sido enviada con éxito!',
            label:
              'Nos pondremos en contacto pronto para programar una demostración de BioAtlas.'
          },
          error: {
            header: 'Ocurrió un error al enviar tu información.',
            label: 'Por favor, inténtalo de nuevo más tarde.'
          }
        },
        contentSuggestion: {
          title: '¿Qué contenido te gustaría estudiar en BioAtlas?',
          moduleLabel: '¿En qué módulo de BioAtlas encaja este contenido?',
          modulePlaceholder: 'Seleccione el módulo',
          titleLabel: 'Título o tema del contenido',
          titlePlaceholder:
            'Ej: Embriología del corazón, Casos clínicos de trauma',
          detailsLabel: 'Detalles adicionales (opcional)',
          detailsPlaceholder:
            'Describe lo que te gustaría ver o cómo este contenido podría ayudar',
          submitting: 'Enviando...',
          submit: 'Enviar sugerencia',
          successMessage:
            '¡Tu sugerencia ha sido enviada con éxito! Gracias por contribuir con BioAtlas.'
        }
      }
    }
  }
}

export { messages }
